import { useEffect, useRef, useState } from "react";
import Icon1 from "../../../../icons/whyAB/Icon1";
import Icon2 from "../../../../icons/whyAB/Icon2";
import Icon3 from "../../../../icons/whyAB/Icon3";
import Icon4 from "../../../../icons/whyAB/Icon4";
import Icon5 from "../../../../icons/whyAB/Icon5";
import Icon6 from "../../../../icons/whyAB/Icon6";
import Icon7 from "../../../../icons/whyAB/Icon7";
import Icon8 from "../../../../icons/whyAB/Icon8";
import CustomScroller from "../../../../shadcn/components/custom/CustomScroller";
import { WhyABCard } from "../../../../shadcn/components/custom/WhyABCard";
import { getWatermarkedImgixUrl } from "services";
interface props {
  className?: string;
}

interface WhyABData {
  className?: string;
  icon?: React.ReactNode;
  indexNo?: string;
  title?: string;
  titleClass?: string;
  iconClass?: string;
  textContent?: string;
  imageLink?: string;
}

const whyABData: WhyABData[] = [
  {
    className: "",
    icon: <Icon1 className="h-6 w-6 lg:w-[42px] lg:h-[42px]" />,
    indexNo: "01",
    title: "Transparency and Trust",
    titleClass: "w-[150px] lg:w-[242px]",
    iconClass: "absolute -right-2 lg:-right-5 top-1 lg:top-[11px]",
    textContent: ` The platform emphasizes transparency in the auction process, ensuring
      that all relevant details about the properties are clearly communicated.
      This builds trust and confidence among users.`,
    imageLink: getWatermarkedImgixUrl(
      `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/5a939d45-5250-4284-b22b-6efb0e8a77fa`,
    ),
  },
  {
    className: "",
    icon: <Icon2 className="h-6 w-6 lg:w-[42px] lg:h-[42px]" />,
    indexNo: "02",
    title: " Comprehensive Property Listings",
    titleClass: "lg:w-[250px]",
    iconClass: "absolute -right-2 lg:-right-10 top-1",
    textContent: `  AuctionBazaar.com offers a wide range of properties from various banks
        and financial institutions across India. This diversity allows users to
        find properties that match their investment goals.`,
    imageLink: getWatermarkedImgixUrl(
      `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/1d753a9a-3fca-455d-99d6-5495d20d9f1d`,
    ),
  },
  {
    className: "",
    icon: <Icon3 className="h-6 w-6 lg:w-[42px] lg:h-[42px]" />,
    indexNo: "03",
    title: " Specialized Platform for NPAs:",
    titleClass: "w-[180px] lg:w-[300px]",
    iconClass: "absolute right-8 lg:right-14 top-1",
    textContent: `  AuctionBazaar.com focuses exclusively on non-performing asset (NPA)
        auctions, making it a specialized platform for buyers and investors
        looking for distressed properties at potentially lower prices.`,
    imageLink: getWatermarkedImgixUrl(
      `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/ce7db1eb-56d8-4fc3-b5ce-4b5b40206f1d`,
    ),
  },
  {
    className: "",
    icon: <Icon4 className="h-6 w-6 lg:w-[42px] lg:h-[42px]" />,
    indexNo: "04",
    title: "User-Friendly Interface",
    titleClass: "w-[140px] lg:w-[250px]",
    iconClass: "absolute -right-4 lg:-right-2 top-1 lg:top-2",
    textContent: ` The website is designed to be user-friendly, making it easy for both
        seasoned investors and first-time buyers to navigate and participate in
        auctions.`,
    imageLink: getWatermarkedImgixUrl(
      `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/e22da04e-f292-4b05-b341-ef367ec4f2c4`,
    ),
  },
  {
    className: "",
    icon: <Icon5 className="h-6 w-6 lg:w-[42px] lg:h-[42px]" />,
    indexNo: "05",
    title: " Expert Support",
    titleClass: "w-[140px] lg:w-[200px]",
    iconClass: "absolute right-12 top-1",
    textContent: `  AuctionBazaar.com provides expert support and guidance throughout the
        auction process, helping users make informed decisions.`,
    imageLink: getWatermarkedImgixUrl(
      `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/ff0970a8-9241-4298-bf90-ef72f6fbf54f`,
    ),
  },
  {
    className: "",
    icon: <Icon6 className="h-6 w-6 lg:w-[42px] lg:h-[42px]" />,
    indexNo: "06",
    title: " Competetive Pricing",
    titleClass: "w-[140px] lg:w-[200px]",
    iconClass: "absolute -right-2 lg:-right-12 top-1 lg:top-1",
    textContent: ` By participating in auctions through AuctionBazaar.com, users have the
        opportunity to acquire properties at competitive prices, often below
        market value`,
    imageLink: getWatermarkedImgixUrl(
      `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/72ae92dd-3139-4930-bf93-6d19830df769`,
    ),
  },
  {
    className: "",
    icon: <Icon7 className="h-6 w-6 lg:w-[42px] lg:h-[42px]" />,
    indexNo: "07",
    title: "Secure Transactions",
    titleClass: "w-[140px] lg:w-[200px]",
    iconClass: "absolute right-10 lg:right-9 top-1",
    textContent: ` The platform ensures that all transactions are secure, with clear terms
        and conditions to protect both buyers and sellers.`,
    imageLink: getWatermarkedImgixUrl(
      `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/60db71a3-327c-4010-8e4a-5a83af0b6bb3`,
    ),
  },
  {
    className: "",
    icon: <Icon8 className="h-6 w-6 lg:w-[42px] lg:h-[42px]" />,
    indexNo: "08",
    title: " Legal Assurance",
    titleClass: "w-[140px] lg:w-[200px]",
    iconClass: "absolute right-14 top-1",
    textContent: ` The platform ensures that all transactions are secure, with clear terms
        and conditions to protect both buyers and sellers.`,
    imageLink: getWatermarkedImgixUrl(
      `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/7e2bad6a-cad1-46e7-8200-3520a8c0557f`,
    ),
  },
];

export function WhyABScroller({ className }: props) {
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const [activeBar, setActiveBar] = useState(1);

  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    if (!scrollContainer) return;

    const updateScrollPosition = () => {
      const scrollPercentage =
        1 *
        (scrollContainer.scrollLeft /
          (scrollContainer.scrollWidth - scrollContainer.clientWidth)) *
        100;
      scrollContainer.style.setProperty(
        "--scroll-position",
        `${2.3 * scrollPercentage}%`,
      );
      //   logic for adjusting the width of the background bar

      if (scrollPercentage < 33) setActiveBar(1);
      else if (scrollPercentage < 67) setActiveBar(2);
      else setActiveBar(3);
    };

    scrollContainer.addEventListener("scroll", updateScrollPosition);
    return () =>
      scrollContainer.removeEventListener("scroll", updateScrollPosition);
  }, []);
  return (
    <>
      <div className="relative flex flex-col">
        <CustomScroller ref={scrollContainerRef} className={`${className} `}>
          {whyABData.map((card, index) => (
            <WhyABCard
              className={card?.className}
              title={card?.title}
              key={`card-${index}`}
              icon={card?.icon}
              titleClass={card?.titleClass}
              textContent={card?.textContent}
              indexNo={card?.indexNo}
              imageLink={card?.imageLink}
              iconClass={card?.iconClass}
            />
          ))}
          <div
            className="lg:hidden absolute 
               custom-scrollbar-track"
          />
        </CustomScroller>
      </div>
    </>
  );
}
